export default __webpack_public_path__ + "static/media/hamburger.13be519e.svg";